import {
  Box,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CharacterCertificatePrint from "./components/character/CharacterCertificatePrint";
import DOBCertificatePrint from "./components/DOB/DOBCertificatePrint";
import SchoolLeavingCertificatePrint from "./components/schoolLeaving/SchoolLeavingCertificatePrint";
import ParticipationCertificate from "./components/participation/ParticipationCertificate";
import BonafideCertificatePrint from "./components/bonafied/BonafideCertificate";
import ExcellenceCertificatePrint from "./components/excellence/ExcellenceCertificate";
import FeeCertificatePrint from "./components/fee/FeeCertificatePrint";
import TeacherExperienceCertificatePrint from "./components/teacherExperience/TeacherExperienceCertificatePrint";

const PreviewCertificate = ({
  state,
  setState,
  handleProceed = () => {},
  certificateName,
}) => {
  const [template, setTemplate] = useState(1);

  // const handleChangeTemplate = (value) => {
  //   setTemplate(value);
  // };
  return (
    <>
      <Stack
        sx={{ m: 1 }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button variant="contained" color="secondary" onClick={handleProceed}>
          Proceed
        </Button>
        {/* <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
            Select Template :
          </Typography>
          <CustomSelectBox
            label="Select Template"
            value={template}
            onChange={(e) => handleChangeTemplate(e.target.value)}
          >
            <MenuItem value={1}>Template 1</MenuItem>
            <MenuItem value={2}>Template 2</MenuItem>
          </CustomSelectBox>
        </Stack> */}
      </Stack>
      <Divider
        sx={{
          backgroundColor: "#000",
          height: "1px",
          width: "100%",
          margin: "0 auto",
        }}
      />

      <Box
        sx={{
          marginTop: "40px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {certificateName === "Character Certificate" && template === 1 && (
          <CharacterCertificatePrint />
        )}
        {certificateName === "Character Certificate" && template === 2 && (
          // <A4CharacterCertificatePrint />
          <Typography>Template 2 is not available</Typography>
        )}
        {certificateName === "Birth Certificate" && template === 1 && (
          <DOBCertificatePrint />
        )}
        {certificateName === "School Leaving Certificate" && template === 1 && (
          <SchoolLeavingCertificatePrint />
        )}
        {certificateName === "Participation Certificate" && template === 1 && (
          <ParticipationCertificate />
        )}
        {certificateName === "Bonafide Certificate" && template === 1 && (
          <BonafideCertificatePrint />
        )}
        {certificateName === "Excellence Certificate" && template === 1 && (
          <ExcellenceCertificatePrint />
        )}
        {certificateName === "Fee Certificate" && template === 1 && (
          <FeeCertificatePrint />
        )}
        {certificateName === "Teacher Experience Certificate" &&
          template === 1 && <TeacherExperienceCertificatePrint />}
      </Box>
    </>
  );
};

export default PreviewCertificate;

